import { Popover } from "@mantine/core";
import { Button, DropdownMenu, DropdownRow } from "@onengine/component-library";
import { IconChevronDown, IconFolderPlus, IconUpload } from "@tabler/icons-react";
import { useState } from "react";
import { useFileManager } from "@/components/core/FileManager";
import { useFileManagerUI } from "@/components/core/FileManager";

const DROPDOWN_STYLE = {
  border: "none",
  boxShadow: "none",
  background: "transparent",
  width: "fit-content",
};

export function FileManagerDropdown() {
  const [opened, setOpened] = useState(false);
  const { currentFolderId, isLocked, permissions } = useFileManager();
  const { openCreateFolder, openUpload } = useFileManagerUI();

  if (!permissions.canCreate || isLocked(currentFolderId, "add")) return null;

  return (
    <Popover opened={opened} onChange={setOpened} position="bottom-end" offset={4} zIndex={100}>
      <Popover.Target>
        <Button
          type="button"
          variant="secondary"
          iconRight={<IconChevronDown size={16} />}
          onClick={() => setOpened((o) => !o)}
          data-slot={"file-manager-header-actions"}
          style={{ minWidth: 70 }}
        >
          New
        </Button>
      </Popover.Target>
      <Popover.Dropdown style={DROPDOWN_STYLE} p={0}>
        <DropdownMenu width={224} scrollable={false}>
          <DropdownRow
            title="File Upload"
            leftSection={<IconUpload size={20} />}
            onClickCapture={() => setOpened(false)}
            onClick={openUpload}
          />
          <DropdownRow
            title="New Folder"
            leftSection={<IconFolderPlus size={20} />}
            onClickCapture={() => setOpened(false)}
            onClick={() => openCreateFolder()}
          />
        </DropdownMenu>
      </Popover.Dropdown>
    </Popover>
  );
}
